import React from "react";
import styles from "./index.module.scss";
import SkeletonC from "../../stories/common/skeleton";

const PropertyListSkeleton = () => {
  return (
    <div className={styles.propertyList}>
      <div className={styles.imgBox}>
        <SkeletonC width="85px" height="65px" />
      </div>
      <div className={styles.address}>
        <SkeletonC width="140px" height="42px" />
      </div>
      <div className={styles.status}>
        <SkeletonC width="90px" height="25px" />
      </div>
      <div className={styles.price}>
        <SkeletonC width="91px" height="25px" />
      </div>
      <div className={styles.agent}>
        <SkeletonC width="160px" height="32px" />
      </div>
      <SkeletonC width="30px" height="30px" shape="circle" />
    </div>
  );
};

export default PropertyListSkeleton;
